import slider1 from "src/Assets/Images/slider/slider-1.webp";
import slider2 from "src/Assets/Images/slider/slider-2.webp";
import slider3 from "src/Assets/Images/slider/slider-3.webp";
import slider4 from "src/Assets/Images/slider/slider-4.webp";

import slider1PNG from "src/Assets/Images/slider/slider-1.png";
import slider2PNG from "src/Assets/Images/slider/slider-2.png";
import slider3PNG from "src/Assets/Images/slider/slider-3.png";
import slider4PNG from "src/Assets/Images/slider/slider-4.png";

export const SliderData = [
  {
    image: slider1,
    pngImage: slider1PNG,
    text: "Restaurant Solution designed to make you grow",
    caption:
      "Streamline your restaurant operations inside out with Nova's all-in-one Restaurant Management System",
  },
  {
    image: slider2,
    pngImage: slider2PNG,
    text: "Future of Restaurant Management System",
    caption:
      "Connect your restaurant 360 degrees digitally from managing your staff to catering to your guest's needs",
  },
  {
    image: slider3,
    pngImage: slider3PNG,
    text: "Grow your restaurant business with us",
    caption:
      "Nova is built with high usability standard which helps to run your business efficiently",
  },
  {
    image: slider4,
    pngImage: slider4PNG,
    text: "Deliver the Best of Guest Experience ",
    caption: "Designed to handle the busiest of hours and boost profit",
  },
];
